// extracted by mini-css-extract-plugin
export default {"educationL1":"EducationL1_educationL1__ThS01","smallPiegraph":"EducationL1_smallPiegraph__KUFjh"};